import React from "react";
import { storageType } from "../function/kiosk";
import { Tab } from "../styled/storage";

const TabMenu = ({ active, setActive, point = "sungsim" }) => {
  return (
    <Tab className={point}>
      {Object.keys(storageType).map((key) => {
        const item = storageType[key];
        return (
          <li
            key={key}
            onClick={() => setActive(parseInt(key))}
            className={`hover${active === parseInt(key) ? ` ${item.key}` : ""}`}>
            {item.label} 보관
          </li>
        );
      })}
    </Tab>
  );
};

export default TabMenu;
